module.exports = __webpack_public_path__ + "static/media/sumit.2ee5a8ee.jpg";